import React from "react";

import type { JSX } from "react";

interface AdBreakMediaIconProps {
  className?: string;
  height?: number;
  width?: number;
}

function AdBreakMediaIcon({
  className,
  height = 40,
  width = 40,
}: AdBreakMediaIconProps): JSX.Element {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 4C4.75 2.20508 6.20508 0.75 8 0.75H24C24.1212 0.75 24.2375 0.798159 24.3232 0.883885L35.1161 11.6768C35.2018 11.7625 35.25 11.8788 35.25 12V36C35.25 37.7949 33.7949 39.25 32 39.25H8C6.20507 39.25 4.75 37.7949 4.75 36V4Z"
        fill="var(--card)"
        stroke="var(--border-strong)"
        strokeWidth="1.5"
      />
      <path
        d="M24 0.5V8C24 10.2091 25.7909 12 28 12H35.5"
        stroke="var(--border-strong)"
        strokeWidth="1.5"
      />
      <path
        d="M20 15V18M20 22.5V25.5M20 30V33M11.2878 19.9906L15.6757 23.3659C15.9562 23.5817 16.0964 23.6895 16.1468 23.821C16.191 23.9363 16.191 24.0637 16.1468 24.179C16.0964 24.3105 15.9562 24.4183 15.6757 24.6341L11.2878 28.0094C10.8742 28.3276 10.6673 28.4867 10.4939 28.4845C10.343 28.4827 10.2009 28.4128 10.1075 28.2943C10 28.1581 10 27.8971 10 27.3753V20.6247C10 20.1029 10 19.8419 10.1075 19.7057C10.2009 19.5872 10.343 19.5173 10.4939 19.5155C10.6673 19.5133 10.8742 19.6724 11.2878 19.9906ZM28.7122 19.9906L24.3243 23.3659C24.0438 23.5817 23.9036 23.6895 23.8532 23.821C23.809 23.9363 23.809 24.0637 23.8532 24.179C23.9036 24.3105 24.0438 24.4183 24.3243 24.6341L28.7122 28.0094C29.1258 28.3276 29.3327 28.4867 29.5061 28.4845C29.6571 28.4827 29.7991 28.4128 29.8925 28.2943C30 28.1581 30 27.8971 30 27.3753V20.6247C30 20.1029 30 19.8419 29.8925 19.7057C29.7991 19.5872 29.6571 19.5173 29.5061 19.5155C29.3327 19.5133 29.1258 19.6724 28.7122 19.9906Z"
        stroke="#E04F16"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
export default AdBreakMediaIcon;
